import { ParameterType } from '@/study-search/enums';

import { IQuery } from '../../interfaces';
import { ParsedFilter } from '../generalizations/ParsedFilter';
import { toArray } from '../../platform/array-extensions';

class QueryParser {
	public parse(query: IQuery): ParsedFilter[] {
		const filters: ParsedFilter[] = [];
		if (query === undefined) return filters;

		this.addFilters(filters, query);

		return filters;
	}

	private addFilters(filters: ParsedFilter[], query: IQuery): void {
		if (query['kw-what'] !== undefined) {
			filters.push(new ParsedFilter(ParameterType.KEYWORD_WHAT, toArray(query['kw-what'])));
		}

		if (query['kw-where'] !== undefined) {
			filters.push(new ParsedFilter(ParameterType.KEYWORD_WHERE, toArray(query['kw-where'])));
		}

		if (query.oi !== undefined) {
			filters.push(new ParsedFilter(ParameterType.ORGANISATIONS, toArray(query.oi)));
		}

		if (query.di !== undefined) {
			filters.push(new ParsedFilter(ParameterType.DISCIPLINES, toArray(query.di)));
		}

		if (query.lv !== undefined) {
			filters.push(new ParsedFilter(ParameterType.EDUCATION_LEVEL, toArray(query.lv)));
		}

		if (query.rg !== undefined) {
			filters.push(new ParsedFilter(ParameterType.CONTINENT, toArray(query.rg)));
		}

		if (query.ci !== undefined) {
			filters.push(new ParsedFilter(ParameterType.COUNTRY, toArray(query.ci)));
		}

		if (query.ae !== undefined) {
			filters.push(new ParsedFilter(ParameterType.AREA, toArray(query.ae)));
		}

		if (query.tr !== undefined) {
			const optionValues = toArray(query.tr)
				.flatMap((v) => v.match(/\[.*?\]/g))
				.filter((v) => v !== null)
				.map((v) => v);
			if (optionValues !== null) {
				filters.push(new ParsedFilter(ParameterType.TUITION_FEE, optionValues));
			}
		}

		if (query.dur !== undefined) {
			const optionValues = toArray(query.dur)
				.flatMap((v) => v.match(/\[.*?\]/g))
				.filter((v) => v !== null)
				.map((v) => v);
			if (optionValues !== null) {
				filters.push(new ParsedFilter(ParameterType.DURATION, optionValues));
			}
		}

		if (query.de !== undefined) {
			filters.push(new ParsedFilter(ParameterType.ATTENDANCE, toArray(query.de)));
		}

		if (query.mh !== undefined) {
			filters.push(new ParsedFilter(ParameterType.DELIVERY_METHOD, toArray(query.mh)));
		}

		if (query.dg !== undefined) {
			filters.push(new ParsedFilter(ParameterType.DEGREE_TYPE, toArray(query.dg)));
		}

		if (query.ef !== undefined) {
			filters.push(new ParsedFilter(ParameterType.EDUCATIONAL_FORM, toArray(query.ef)));
		}

		if (query.sps !== undefined) {
			filters.push(new ParsedFilter(ParameterType.SPECIAL_PROGRAMMES, toArray(query.sps)));
		}

		if (query.uc !== undefined) {
			filters.push(new ParsedFilter(ParameterType.USER_COUNTRY, toArray(query.uc)));
		}

		if (query.tc !== undefined) {
			filters.push(new ParsedFilter(ParameterType.CURRENCY, toArray(query.tc)));
		}
	}
}

export default new QueryParser();
